import { Alert } from "@circleco/compass/components/Alert";
import { Typography } from "@circleco/compass/components/Typography";

import { t } from "@/i18n-js/instance";

import { UpgradeTargetTrialBadge } from "./UpgradeTargetTrialBadge";

const i18nRoot = "paywall_checkout.offer_page.upgrade";

export const UpgradePreviewStatus = ({
  isLoading = false,
  message,
  targetTrialDays,
}: {
  isLoading?: boolean;
  message?: string;
  targetTrialDays?: number;
}) => {
  if (isLoading) {
    // The skeletons carry the visual loading state; this is only the
    // announcement for assistive tech.
    return (
      <>
        <output className="sr-only" aria-busy="true">
          <Typography variant="body-md" color="secondary">
            {t([i18nRoot, "loading"])}
          </Typography>
        </output>
        <UpgradeTargetTrialBadge days={targetTrialDays} />
      </>
    );
  }

  if (!message) return null;

  return (
    <div className="w-full max-w-xl">
      <Alert
        data-testid="upgrade-preview-error"
        variant="destructive"
        icon="circle-info"
        description={<Typography variant="body-sm">{message}</Typography>}
      />
    </div>
  );
};
